import React, { useState, useCallback } from 'react'
import { Button, Tooltip } from 'antd'
import { Deposit } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { EyeOutlined, CloudDownloadOutlined } from '@ant-design/icons'
import { DepositsDetailsModal } from 'src/components'

const DepositsActionColumn: React.FC<{ deposit: Deposit }> = ({ deposit }) => {
  const { t } = useTranslation()
  const [isModalVisible, setIsModalVisible] = useState(false)

  const handleShowDetails = useCallback(() => {
    setIsModalVisible(true)
  }, [])

  const handleDownloadReceipt = useCallback(() => {
    window.open(deposit.bank_transfer_receipt, '_blank')
  }, [deposit])

  return (
    <>
      <Tooltip title={t('Deposits.ShowDetails')} color={'blue'}>
        <Button
          type='ghost'
          size='middle'
          shape='circle'
          className={`radius-100 ml-2`}
          onClick={handleShowDetails}
          icon={<EyeOutlined />}
        />
      </Tooltip>
      {deposit?.bank_transfer_receipt && (
        <Tooltip title={t('Deposits.ShowDetails')} color='blue'>
          <Button
            type='ghost'
            size='middle'
            shape='circle'
            className={`radius-100 ml-2`}
            icon={<CloudDownloadOutlined />}
            onClick={handleDownloadReceipt}
          />
        </Tooltip>
      )}



      <DepositsDetailsModal
        isModalVisible={isModalVisible}
        handleCancel={() => setIsModalVisible(false)}
        deposit={deposit}
      />
    </>
  )
}

export default DepositsActionColumn
